export const BillingSvg = ({ props, active }) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 22.75H3c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h18c.41 0 .75.34.75.75s-.34.75-.75.75zM5.6 19.75H4c-.96 0-1.75-.79-1.75-1.75V9.38c0-.96.79-1.75 1.75-1.75h1.6c.96 0 1.75.79 1.75 1.75V18c0 .96-.79 1.75-1.75 1.75zM4 9.12c-.14 0-.25.11-.25.25V18c0 .14.11.25.25.25h1.6c.14 0 .25-.11.25-.25V9.38c0-.14-.11-.25-.25-.25H4v-.01zM12.8 19.75h-1.6c-.96 0-1.75-.79-1.75-1.75V6.19c0-.96.79-1.75 1.75-1.75h1.6c.96 0 1.75.79 1.75 1.75V18c0 .96-.79 1.75-1.75 1.75zM11.2 5.94c-.14 0-.25.11-.25.25V18c0 .14.11.25.25.25h1.6c.14 0 .25-.11.25-.25V6.19c0-.14-.11-.25-.25-.25h-1.6zM20 19.75h-1.6c-.96 0-1.75-.79-1.75-1.75V3c0-.96.79-1.75 1.75-1.75H20c.96 0 1.75.79 1.75 1.75v15c0 .96-.79 1.75-1.75 1.75zm-1.6-17c-.14 0-.25.11-.25.25v15c0 .14.11.25.25.25H20c.14 0 .25-.11.25-.25V3c0-.14-.11-.25-.25-.25h-1.6z"
        fill={active ? '#FF6A00' : '#fff'}
      />
    </svg>
  );
};
